<div class="d-flex align-items-center gap-2 cfg-table-toolbar">
  @if (searchFields()) {
    <div class="cfg-table-search">
      <app-search-input [(searchText)]="searchText" [placeholder]="searchPlaceholder()"
        [autofocus]="searchAutofocus()" (keyup.enter)="onSearchEnter()" />
    </div>
  }
  <ng-content select="[cfgToolbar]" />
</div>

@switch (state()) {
  @case ('loading') {
    <app-continuous-loading-bar [dataToDisplay]="loadingText()" />
  }
  @case ('error') {
    <div class="d-flex flex-column align-items-center py-5" role="alert">
      <div>
        <h5 class="d-inline">{{ errorText() }}</h5>
        <i class="fa-solid fa-triangle-exclamation text-danger ms-2" aria-hidden="true"></i>
      </div>
      <button type="button" class="btn btn-outline-primary mt-2" (click)="resource().reload()">Prøv igen</button>
    </div>
  }
  @default {
    <div #wrap class="table-wrap mt-2" [style.height]="height()">
      <table class="table table-hover table-striped" [class.config-hover]="rowLink() !== null">
        @if (state() === 'empty') {
          <thead>
            <tr>
              <th class="no-data">
                @if (emptyTemplate(); as empty) {
                  <ng-container [ngTemplateOutlet]="empty.templateRef" />
                } @else {
                  {{ emptyText() }}
                }
              </th>
            </tr>
          </thead>
        } @else {
          <thead class="thead-sticky">
            <tr>
              @for (col of columns(); track col.key) {
                <th scope="col" [style.width]="col.width ?? null" [class]="col.headerClass ?? ''"
                  [class.cfg-th-sortable]="isSortable(col)" [attr.aria-sort]="ariaSortFor(col)">
                  @if (isSortable(col)) {
                    <button type="button" class="cfg-sort-btn" (click)="cycleSort(col)">
                      {{ col.header }}
                      @if (sortMarker(col); as marker) {
                        <i class="fa-solid ms-1" [class]="marker" aria-hidden="true"></i>
                      }
                    </button>
                  } @else {
                    {{ col.header }}
                  }
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of visibleRows(); track trackBy()(row); let i = $index) {
              @let link = resolveLink(row);
              <tr (click)="rowClick.emit(row)">
                @for (col of columns(); track col.key) {
                  @let tpl = templateFor(col.key);
                  @if (tpl) {
                    <td [class]="col.cellClass ?? ''" [class.cfg-cell-interactive]="col.interactive ?? true">
                      <ng-container [ngTemplateOutlet]="tpl" [ngTemplateOutletContext]="cellContext(row, col, i)" />
                    </td>
                  } @else {
                    <td class="text-truncate" [class]="col.cellClass ?? ''"
                      [style.max-width]="maxWidthFor(col)" appTruncateTooltip ngbTooltip triggers="manual"
                      container="body" placement="top-start">
                      @if (link) {
                        <a class="stretched-link text-decoration-none" [routerLink]="link"
                          [attr.aria-label]="isLinkColumn(col) ? rowLabelFor(row, col) : null"
                          [attr.aria-hidden]="isLinkColumn(col) ? null : 'true'"
                          [attr.tabindex]="isLinkColumn(col) ? null : '-1'">{{ cellValue(row, col) }}</a>
                      } @else {
                        {{ cellValue(row, col) }}
                      }
                    </td>
                  }
                }
              </tr>
            }
            @if (hasMore()) {
              <tr class="cfg-sentinel-row">
                <td [attr.colspan]="columns().length">
                  <div #sentinel class="cfg-sentinel" aria-hidden="true"></div>
                </td>
              </tr>
            }
          </tbody>
        }
      </table>
    </div>
  }
}
